import React from 'react';
//CarbonComponents
import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableHeader,
  TableBody,
  SkeletonText
} from 'carbon-components-react';
import RowItem from './RowItem';

interface Props {
  title: string;
  description: string;
  rowData: any[];
  headerData: any[];
  isLoading?: boolean;
  isIconColumn?: boolean;
  rowClassName?: (row: any) => string | string;
  selectedRowId?: string;
  selectedRowHandler?: Function;
  size?: string;
  onClickHeader?: Function;
  sortDirection?: string;
  sortingHeader?: string;
}

export const DataTableBasicViewComponent: React.FC<Props> = ({
  title,
  description,
  headerData,
  rowData,
  rowClassName = '',
  selectedRowId,
  selectedRowHandler,
  size = 'normal',
  isLoading = false,
  onClickHeader,
  sortDirection,
  sortingHeader
}: any) => {
  return (
    <DataTable
      rows={rowData}
      headers={headerData}
      size={size}
      render={({ rows, headers, getHeaderProps }: any) => (
        <TableContainer title={title} description={description}>
          <Table size={size} className="data-table--wrapper">
            <TableHead>
              <TableRow>
                {headers.map((header: any) => (
                  <TableHeader
                    key={header.key}
                    {...getHeaderProps({
                      header,
                      isSortable: header?.isSortable
                    })}
                    isSortHeader={sortingHeader === header.key}
                    sortDirection={sortDirection}
                    onClick={() => onClickHeader(header.key)}
                  >
                    <div
                      className={`header-text ${
                        header.className ? header.className : ''
                      }`}
                    >
                      {header.header}
                    </div>
                  </TableHeader>
                ))}
                {/* <TableHeader></TableHeader> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading && headerData
                ? headerData.map((item: any) => {
                    return (
                      <TableRow key={item.key}>
                        {headerData.map((i: any) => (
                          <td key={`s_${i.key}`}>
                            <SkeletonText />
                          </td>
                        ))}
                      </TableRow>
                    );
                  })
                : rows.map((row: any) => {
                    return (
                      <TableRow
                        isSelected={row.id === selectedRowId}
                        className={
                          typeof rowClassName === 'function'
                            ? rowClassName(row)
                            : rowClassName
                        }
                        key={row.id}
                        onClick={() =>
                          selectedRowHandler && selectedRowHandler(row)
                        }
                      >
                        {row.cells.map((cell: any) => {
                          return (
                            <RowItem key={cell.id} cell={cell} rowId={row.id} />
                          );
                        })}
                      </TableRow>
                    );
                  })}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    />
  );
};

export default React.memo(DataTableBasicViewComponent);
